export const validateEmail = (email: string) => {
  if (!email) return false;
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

export const validatePassword = (password: string) => {
  if (!password) return "Pole wymagane";
  let validated = password.length >= 8;
  if (validated) {
    if (!/\d/.test(password)) validated = false;
    if (!/[a-z]/.test(password)) validated = false;
    if (!/[A-Z]/.test(password)) validated = false;
  }
  return !validated ? "Hasło jest niewystarczająco silne." : "";
};
